module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.kostprisPrTime"
    }
  }), _vm._v("\n        Kostpris pr. time\n    ")], 1), _vm._v(" "), (_vm.data && !_vm.loading && _vm.data.accounts_total && _vm.data.total_hours) ? _c('div', {
    staticClass: "placeholder padding box"
  }, [_c('div', {
    staticClass: "large"
  }, [_vm._v("\n            " + _vm._s(_vm._f("currency")(_vm.data.costprice_per_hour)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_vm._v("\n            Udregningen er baseret på de totale udgifter til svende divideret med antal timer brugt hos kunderne i perioden\n            "), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.showCalculations) ? _c('div', {
    staticClass: "accounts"
  }, [_vm._l((_vm.data.calculations), function(account) {
    return _c('div', {
      key: account.uuid,
      staticClass: "account"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                        " + _vm._s(account.name) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(Math.abs(account.total_balance))) + "\n                    ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "account total"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        Total\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.data.accounts_total)) + "\n                    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "account total"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        Antal timer hos kunderne\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("number")(_vm.data.total_hours)) + "\n                    ")])])], 2) : _vm._e()])]) : (!_vm.data && _vm.loading) ? _c('box-loading', {
    attrs: {
      "height": "350"
    }
  }) : _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n        Vi kunne ikke udregne kostprisen. Tjek, at du har angivet hvilke medarbejdere og konti, der skal regnes med i denne udregning. Dette kan du ændre i indstillingerne\n    ")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e1cbaa30", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1cbaa30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/components/costpricePerHour.vue
// module id = 889
// module chunks = 0